import { useCallback, useEffect } from 'react';

// useEffect used inside of app.tsx disabling scroll inside of numeric cells

export const useNoScroll = () => {
  const wheelCallback = useCallback(() => {
    if (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      document.activeElement?.type === 'number' &&
      document.activeElement?.classList.contains('noscroll')
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      document.activeElement?.blur();
    }
  }, []);

  useEffect(() => {
    document.addEventListener('wheel', wheelCallback);
    return () => document.removeEventListener('wheel', wheelCallback);
  }, [wheelCallback]);
};
